import { render, staticRenderFns } from "./ClaimTable.vue?vue&type=template&id=500e7363&scoped=true&"
import script from "./ClaimTable.vue?vue&type=script&lang=js&"
export * from "./ClaimTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e7363",
  null
  
)

export default component.exports